<template>
<div id="starletapplicationform">
  <div class="nopadding col-md-12 col-sm-6 col-xs-12 pull-right">
    <button class="yfu-btn" v-on:click="toggleStarletApplicatioForm()"><span class="btn-fav absolute"><i class="fa fa-star"></i></span>jetzt melden<span class="btn-arrow absolute"><i class="fa fa-chevron-right" aria-hidden="true"></i></span></button>
  </div>
  <div class="col-12">
    <form  class="yfu_form" v-if="formShow" v-on:submit.prevent="validateBeforeSubmit('student_profile_lead',formData)">
      <div class="modal-wrap layer-4 fixed bg-1 scroll" v-on:click="hideModal()"></div>
      <div v-show="sended == false" class="student-modal">
        <br>
        <fieldset class="col-md-12">
          <div class="col-12">
            <div class="pull-right" v-on:click="hideModal()">
              <i class="close fa fa-times"></i>
            </div>
            <h2 class="hero_submit center-text">Ihre Meldung</h2>
            <br>
            <p>
              Dies ist keine verbindliche Anmeldung als Gastfamilie.<br> Nach Absenden des Formulars erhalten Sie eine E-Mail mit weiteren Informationen zu den nächsten Schritten.
            </p>
          </div>
          <div class="col-md-6 col-12">
            <label class="pull-left salute">
              <input class="pull-left" type="radio" v-model="formData.salute" id="herr" value="mr"/>
              Herr</label>
            <label class="pull-left salute">
              <input class="pull-left" type="radio" v-model="formData.salute" id="frau" value="mrs"/>
               Frau</label>
          </div>
          <div class="row col-12">
            <div class="form-group col-md-6">
              <label>Vorname
                <input class="form-control" v-model="formData.firstname" name="firstname" placeholder="Bitte geben Sie Ihren Vorname ein." v-validate="{ required: true }"/>
              </label>
              <div class="validation-error" v-show="errors.has('firstname')">
                <p class="error">Bitte geben Sie Ihre Vornamen an.</p>
              </div>
              <label>Nachname
                <input class="form-control" v-model="formData.lastname" name="lastname" placeholder="Bitte geben Sie Ihren Nachnamen ein." v-validate="'required'"/>
              </label>
              <div class="validation-error" v-if="errors.has('lastname')">
                <p class="error">Bitte geben Sie Ihre Nachnamen an.</p>
              </div>
              <label>E-Mail
                <input class="form-control" v-model="formData.email" name="email" placeholder="Bitte geben Sie Ihre E-mail ein." v-validate="'required|email'"/>
              </label>
              <div class="validation-error" v-if="errors.has('email')">
                <p class="error">Bitte geben Sie Ihre E-Mail an.</p>
              </div>
              <label>Telefon
                <input class="form-control" v-model="formData.phone" name="phone" placeholder="Bitte geben Sie Ihre Telefonnummer ein." v-validate="'required'"/>
              </label>
              <div class="validation-error" v-if="errors.has('phone')">
                <p class="error">Bitte geben Sie Ihre Telefonnummer ein.</p>
              </div>
            </div>
            <div class="form-group col-md-6">
            <label>Straße
              <input class="form-control" v-model="formData.street" name="street" placeholder="Bitte geben Sie Ihre Straße ein." v-validate="'required'"/>
            </label>
            <div class="validation-error" v-if="errors.has('street')">
              <p class="error">Bitte geben Sie Ihre Straße an.</p>
            </div>
            <label>Postleitzahl
              <input class="form-control" v-model="formData.zip" name="zip" placeholder="Bitte geben Sie Ihre Postleitzahl ein." v-validate="'required'"/>
            </label>
            <div class="validation-error" v-if="errors.has('zip')">
              <p class="error">Bitte geben Sie Ihre Postleitzahl an.</p>
            </div>
            <label>Stadt
              <input class="form-control" v-model="formData.city" name="city" placeholder="Bitte geben Sie Ihren Wohnort ein." v-validate="'required'"/>
            </label>
            <div class="validation-error" v-if="errors.has('city')">
              <p class="error">Bitte geben Sie Ihre Stadt an.</p>
            </div>
            <br>
          </div>
            <div class="col-12">
            <button class="nomargin host-btn pull-right col-md-6 col-lg-4" type="submit">
              <h5>Meldung abschicken</h5> <span class="btn-arrow absolute"><i aria-hidden="true" class="fa fa-chevron-right"></i></span>
            </button>
          </div>
          </div>
          <br>
          <br>
          <br>
        </fieldset>
      </div>
      <div v-show="sended" class="student-modal">
        <br>
        <div class="pull-right" @click="hideModal()">
          <i class="close fa fa-times"></i>
        </div>
        <br>
        <br>
        <br>
        <br>
        <h3 class="center-text"><i class="far fa-smile"></i><br><br>
          Vielen Dank für Ihre Meldung!<br>
          Wir werden uns in Kürze mit Ihnen in Verbindung setzen.</h3>
        <br>
        <br>
        <br>
        <br>
      </div>
    </form>
  </div>
</div>
</template>
<script>
export default {
  props: ["sended"],
  data() {
    return {
      formData: {
        salute: "mr",
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        street: "",
        zip: "",
        city: "",
        startletsId:[]
      },
      formShow: false
    };
  },
  components: {

  },
  methods: {
    toggleStarletApplicatioForm: function() {
      var self = this;
      document.getElementsByTagName("BODY")[0].classList.add('no-scroll');
      self.formShow = !self.formShow
    },
    sendFormPost: function(url, obj) {
      obj.id = this.$parent.starlets.map(function(starlet) {
        return starlet.id
      });
      if (!obj == 0) {
        this.$parent.getDatasAsUriParameters(obj)
      };
      this.$parent.postData(url, obj);
    },
    validateBeforeSubmit(url, obj) {
      var self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          self.sendFormPost(url, obj);
          return;
        }
      });
    },
    hideModal: function() {
      var self = this;
      document.getElementsByTagName("BODY")[0].classList.remove('no-scroll');
      self.formShow = false;
    }
  }
};
</script>
